declare var $:any;
import {DELETE_QUERY, GET_QUERY, POST_QUERY, POSTMULTIPART_QUERY, PUT_QUERY} from "./utils";


export const API = {

  delete(path:string) {
    return new Promise<any>((resolve, reject) => {
      $.ajax(DELETE_QUERY(path))
        .done(response => {
          resolve(response);
        })
        .fail((err) => {
          reject(err);
        });
    });
  },

  get(path:string) {
    return new Promise<any>((resolve, reject) => {
      $.ajax(GET_QUERY(path))
        .done(response => {
          resolve(response);
        })
        .fail((err) => {
          reject(err);
        });
    });
  },

  post(path:string, data) {
    return new Promise<any>((resolve, reject) => {
      $.ajax(POST_QUERY(path, data))
        .done(response => {
          resolve(response);
        })
        .fail((err) => {
          reject(err);
        });
    });
  },

  put(path:string, data) {
    return new Promise<any>((resolve, reject) => {
      $.ajax(PUT_QUERY(path, data))
        .done(response => {
          resolve(response);
        })
        .fail((err) => {
          reject(err);
        });
    });
  },

  postMultipart(path, data:any){
    return new Promise<any>((resolve, reject) => {
      $.ajax(POSTMULTIPART_QUERY(path, data))
      .done(response => {
        resolve(response);
      })
      .fail((err) => {
        reject(err);
      });
    });
  },


}
